export default "__VITE_ASSET__3cb7e842__"